var SECTION_ID_ATTR$1 = "data-section-id";
function Section(container, properties) {
  ((this.container = validateContainerElement(container)),
    (this.id = container.getAttribute(SECTION_ID_ATTR$1)),
    (this.extensions = []),
    Object.assign(this, validatePropertiesObject(properties)),
    this.onLoad());
}
function validateContainerElement(container) {
  if (!(container instanceof Element))
    throw new TypeError(
      "Theme Sections: Attempted to load section. The section container provided is not a DOM element.",
    );
  if (null === container.getAttribute(SECTION_ID_ATTR$1))
    throw new Error(
      "Theme Sections: The section container provided does not have an id assigned to the " +
        SECTION_ID_ATTR$1 +
        " attribute.",
    );
  return container;
}
function validatePropertiesObject(value) {
  if ((void 0 !== value && "object" != typeof value) || null === value)
    throw new TypeError("Theme Sections: The properties object provided is not a valid");
  return value;
}
((Section.prototype = {
  onLoad: Function.prototype,
  onUnload: Function.prototype,
  onSelect: Function.prototype,
  onDeselect: Function.prototype,
  onBlockSelect: Function.prototype,
  onBlockDeselect: Function.prototype,
  extend: function (extension) {
    this.extensions.push(extension);
    var extensionClone = Object.assign({}, extension);
    (delete extensionClone.init,
      Object.assign(this, extensionClone),
      "function" == typeof extension.init && extension.init.apply(this));
  },
}),
  "function" != typeof Object.assign &&
    Object.defineProperty(Object, "assign", {
      value: function (target) {
        if (null == target) throw new TypeError("Cannot convert undefined or null to object");
        for (var to = Object(target), index = 1; index < arguments.length; index++) {
          var nextSource = arguments[index];
          if (null != nextSource)
            for (var nextKey in nextSource)
              Object.prototype.hasOwnProperty.call(nextSource, nextKey) && (to[nextKey] = nextSource[nextKey]);
        }
        return to;
      },
      writable: !0,
      configurable: !0,
    }));
var SECTION_TYPE_ATTR = "data-section-type",
  SECTION_ID_ATTR = "data-section-id";
((window.Shopify = window.Shopify || {}),
  (window.Shopify.theme = window.Shopify.theme || {}),
  (window.Shopify.theme.sections = window.Shopify.theme.sections || {}));
var registered = (window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {}),
  instances = (window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || []);
function register(type, properties) {
  if ("string" != typeof type)
    throw new TypeError(
      "Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered",
    );
  if (void 0 !== registered[type])
    throw new Error(
      'Theme Sections: A section of type "' +
        type +
        '" has already been registered. You cannot register the same section type twice',
    );
  function TypedSection(container) {
    Section.call(this, container, properties);
  }
  return (
    (TypedSection.constructor = Section),
    ((TypedSection.prototype = Object.create(Section.prototype)).type = type),
    (registered[type] = TypedSection)
  );
}
function load(types, containers) {
  ((types = normalizeType(types)),
    void 0 === containers && (containers = document.querySelectorAll("[" + SECTION_TYPE_ATTR + "]")),
    (containers = normalizeContainers(containers)),
    types.forEach(function (type) {
      var TypedSection = registered[type];
      void 0 !== TypedSection &&
        (containers = containers.filter(function (container) {
          return !(
            isInstance(container) ||
            null === container.getAttribute(SECTION_TYPE_ATTR) ||
            (container.getAttribute(SECTION_TYPE_ATTR) === type && (instances.push(new TypedSection(container)), 1))
          );
        }));
    }));
}
function unload(selector) {
  getInstances(selector).forEach(function (instance) {
    var index = instances
      .map(function (e) {
        return e.id;
      })
      .indexOf(instance.id);
    (instances.splice(index, 1), instance.onUnload());
  });
}
function getInstances(selector) {
  var filteredInstances = [];
  if (NodeList.prototype.isPrototypeOf(selector) || Array.isArray(selector)) var firstElement = selector[0];
  return (
    selector instanceof Element || firstElement instanceof Element
      ? normalizeContainers(selector).forEach(function (container) {
          filteredInstances = filteredInstances.concat(
            instances.filter(function (instance) {
              return instance.container === container;
            }),
          );
        })
      : ("string" != typeof selector && "string" != typeof firstElement) ||
        normalizeType(selector).forEach(function (type) {
          filteredInstances = filteredInstances.concat(
            instances.filter(function (instance) {
              return instance.type === type;
            }),
          );
        }),
    filteredInstances
  );
}
function getInstanceById(id) {
  for (var instance, i = 0; i < instances.length; i++)
    if (instances[i].id === id) {
      instance = instances[i];
      break;
    }
  return instance;
}
function isInstance(selector) {
  return getInstances(selector).length > 0;
}
function normalizeType(types) {
  return (
    "*" === types
      ? (types = Object.keys(registered))
      : "string" == typeof types
        ? (types = [types])
        : types.constructor === Section
          ? (types = [types.prototype.type])
          : Array.isArray(types) &&
            types[0].constructor === Section &&
            (types = types.map(function (TypedSection) {
              return TypedSection.prototype.type;
            })),
    types.map(function (type) {
      return type.toLowerCase();
    })
  );
}
function normalizeContainers(containers) {
  return (
    NodeList.prototype.isPrototypeOf(containers) && containers.length > 0
      ? (containers = Array.prototype.slice.call(containers))
      : (NodeList.prototype.isPrototypeOf(containers) && 0 === containers.length) || null === containers
        ? (containers = [])
        : !Array.isArray(containers) && containers instanceof Element && (containers = [containers]),
    containers
  );
}
function n$2(n, t) {
  return (void 0 === t && (t = document), t.querySelector(n));
}
function t$2(n, t) {
  return (void 0 === t && (t = document), [].slice.call(t.querySelectorAll(n)));
}
function c$1(n, t) {
  return Array.isArray(n) ? n.forEach(t) : t(n);
}
function r$2(n) {
  return function (t, r, e) {
    return c$1(t, function (t) {
      return t[n + "EventListener"](r, e);
    });
  };
}
function e$2(n, t, c) {
  return (
    r$2("add")(n, t, c),
    function () {
      return r$2("remove")(n, t, c);
    }
  );
}
function o$2(n) {
  return function (t) {
    var r = arguments;
    return c$1(t, function (t) {
      var c;
      return (c = t.classList)[n].apply(c, [].slice.call(r, 1));
    });
  };
}
function u$1(n) {
  o$2("add").apply(void 0, [n].concat([].slice.call(arguments, 1)));
}
function i$1(n) {
  o$2("remove").apply(void 0, [n].concat([].slice.call(arguments, 1)));
}
function l(n) {
  o$2("toggle").apply(void 0, [n].concat([].slice.call(arguments, 1)));
}
function a$1(n, t) {
  return n.classList.contains(t);
}
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x.default : x;
}
window.Shopify.designMode &&
  (document.addEventListener("shopify:section:load", function (event) {
    var container,
      id = event.detail.sectionId;
    null !==
      (container = window.Shopify.visualPreviewMode
        ? event.target.querySelector("[data-section-id]")
        : event.target.querySelector("[" + SECTION_ID_ATTR + '="' + id + '"]')) &&
      load(container.getAttribute(SECTION_TYPE_ATTR), container);
  }),
  document.addEventListener("shopify:section:unload", function (event) {
    var container = event.target.querySelector("[" + SECTION_ID_ATTR + '="' + event.detail.sectionId + '"]');
    "object" == typeof getInstances(container)[0] && unload(container);
  }),
  document.addEventListener("shopify:section:select", function (event) {
    var instance = getInstanceById(event.detail.sectionId);
    "object" == typeof instance && instance.onSelect(event);
  }),
  document.addEventListener("shopify:section:deselect", function (event) {
    var instance = getInstanceById(event.detail.sectionId);
    "object" == typeof instance && instance.onDeselect(event);
  }),
  document.addEventListener("shopify:block:select", function (event) {
    var instance = getInstanceById(event.detail.sectionId);
    "object" == typeof instance && instance.onBlockSelect(event);
  }),
  document.addEventListener("shopify:block:deselect", function (event) {
    var instance = getInstanceById(event.detail.sectionId);
    "object" == typeof instance && instance.onBlockDeselect(event);
  }));
var isMobile$2 = { exports: {} };
((isMobile$2.exports = isMobile), (isMobile$2.exports.isMobile = isMobile), (isMobile$2.exports.default = isMobile));
var mobileRE =
    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i,
  tabletRE =
    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|android|ipad|playbook|silk/i;
function isMobile(opts) {
  opts || (opts = {});
  var ua = opts.ua;
  if (
    (ua || "undefined" == typeof navigator || (ua = navigator.userAgent),
    ua && ua.headers && "string" == typeof ua.headers["user-agent"] && (ua = ua.headers["user-agent"]),
    "string" != typeof ua)
  )
    return !1;
  var result = opts.tablet ? tabletRE.test(ua) : mobileRE.test(ua);
  return (
    !result &&
      opts.tablet &&
      opts.featureDetect &&
      navigator &&
      navigator.maxTouchPoints > 1 &&
      -1 !== ua.indexOf("Macintosh") &&
      -1 !== ua.indexOf("Safari") &&
      (result = !0),
    result
  );
}
var isMobile$1 = isMobile$2.exports,
  browser = { exports: {} };
!(function (module, exports) {
  function Delegate(root) {
    ((this.listenerMap = [{}, {}]),
      root && this.root(root),
      (this.handle = Delegate.prototype.handle.bind(this)),
      (this._removedListeners = []));
  }
  function matchesTag(tagName, element) {
    return tagName.toLowerCase() === element.tagName.toLowerCase();
  }
  function matchesRoot(selector, element) {
    return this.rootElement === window
      ? element === document || element === document.documentElement || element === window
      : this.rootElement === element;
  }
  function matchesId(id, element) {
    return id === element.id;
  }
  (Object.defineProperty(exports, "__esModule", { value: !0 }),
    (exports.default = void 0),
    (Delegate.prototype.root = function (root) {
      var eventType,
        listenerMap = this.listenerMap;
      if (this.rootElement) {
        for (eventType in listenerMap[1])
          listenerMap[1].hasOwnProperty(eventType) && this.rootElement.removeEventListener(eventType, this.handle, !0);
        for (eventType in listenerMap[0])
          listenerMap[0].hasOwnProperty(eventType) && this.rootElement.removeEventListener(eventType, this.handle, !1);
      }
      if (!root || !root.addEventListener) return (this.rootElement && delete this.rootElement, this);
      for (eventType in ((this.rootElement = root), listenerMap[1]))
        listenerMap[1].hasOwnProperty(eventType) && this.rootElement.addEventListener(eventType, this.handle, !0);
      for (eventType in listenerMap[0])
        listenerMap[0].hasOwnProperty(eventType) && this.rootElement.addEventListener(eventType, this.handle, !1);
      return this;
    }),
    (Delegate.prototype.captureForType = function (eventType) {
      return -1 !== ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(eventType);
    }),
    (Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
      var root, listenerMap, matcher, matcherParam;
      if (!eventType) throw new TypeError("Invalid event type: " + eventType);
      if (
        ("function" == typeof selector && ((useCapture = handler), (handler = selector), (selector = null)),
        void 0 === useCapture && (useCapture = this.captureForType(eventType)),
        "function" != typeof handler)
      )
        throw new TypeError("Handler must be a type of Function");
      return (
        (root = this.rootElement),
        (listenerMap = this.listenerMap[useCapture ? 1 : 0])[eventType] ||
          (root && root.addEventListener(eventType, this.handle, useCapture), (listenerMap[eventType] = [])),
        selector
          ? /^[a-z]+$/i.test(selector)
            ? ((matcherParam = selector), (matcher = matchesTag))
            : /^#[a-z0-9\-_]+$/i.test(selector)
              ? ((matcherParam = selector.slice(1)), (matcher = matchesId))
              : ((matcherParam = selector), (matcher = Element.prototype.matches))
          : ((matcherParam = null), (matcher = matchesRoot.bind(this))),
        listenerMap[eventType].push({
          selector: selector,
          handler: handler,
          matcher: matcher,
          matcherParam: matcherParam,
        }),
        this
      );
    }),
    (Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
      var i, listener, listenerMap, listenerList, singleEventType;
      if (
        ("function" == typeof selector && ((useCapture = handler), (handler = selector), (selector = null)),
        void 0 === useCapture)
      )
        return (this.off(eventType, selector, handler, !0), this.off(eventType, selector, handler, !1), this);
      if (((listenerMap = this.listenerMap[useCapture ? 1 : 0]), !eventType)) {
        for (singleEventType in listenerMap)
          listenerMap.hasOwnProperty(singleEventType) && this.off(singleEventType, selector, handler);
        return this;
      }
      if (!(listenerList = listenerMap[eventType]) || !listenerList.length) return this;
      for (i = listenerList.length - 1; i >= 0; i--)
        ((listener = listenerList[i]),
          (selector && selector !== listener.selector) ||
            (handler && handler !== listener.handler) ||
            (this._removedListeners.push(listener), listenerList.splice(i, 1)));
      return (
        listenerList.length ||
          (delete listenerMap[eventType],
          this.rootElement && this.rootElement.removeEventListener(eventType, this.handle, useCapture)),
        this
      );
    }),
    (Delegate.prototype.handle = function (event) {
      var i,
        l,
        root,
        listener,
        target,
        type = event.type,
        listenerList = [];
      if (!0 !== event.ftLabsDelegateIgnore) {
        switch (
          (3 === (target = event.target).nodeType && (target = target.parentNode),
          target.correspondingUseElement && (target = target.correspondingUseElement),
          (root = this.rootElement),
          event.eventPhase || (event.target !== event.currentTarget ? 3 : 2))
        ) {
          case 1:
            listenerList = this.listenerMap[1][type];
            break;
          case 2:
            (this.listenerMap[0] &&
              this.listenerMap[0][type] &&
              (listenerList = listenerList.concat(this.listenerMap[0][type])),
              this.listenerMap[1] &&
                this.listenerMap[1][type] &&
                (listenerList = listenerList.concat(this.listenerMap[1][type])));
            break;
          case 3:
            listenerList = this.listenerMap[0][type];
        }
        var ret,
          toFire = [];
        for (l = listenerList.length; target && l; ) {
          for (i = 0; i < l && (listener = listenerList[i]); i++)
            target.tagName &&
            ["button", "input", "select", "textarea"].indexOf(target.tagName.toLowerCase()) > -1 &&
            target.hasAttribute("disabled")
              ? (toFire = [])
              : listener.matcher.call(target, listener.matcherParam, target) && toFire.push([event, target, listener]);
          if (target === root) break;
          if (((l = listenerList.length), (target = target.parentElement || target.parentNode) instanceof HTMLDocument))
            break;
        }
        for (i = 0; i < toFire.length; i++)
          if (!(this._removedListeners.indexOf(toFire[i][2]) > -1) && !1 === this.fire.apply(this, toFire[i])) {
            ((toFire[i][0].ftLabsDelegateIgnore = !0), toFire[i][0].preventDefault(), (ret = !1));
            break;
          }
        return ret;
      }
    }),
    (Delegate.prototype.fire = function (event, target, listener) {
      return listener.handler.call(target, event, target);
    }),
    (Delegate.prototype.destroy = function () {
      (this.off(), this.root());
    }),
    (exports.default = Delegate),
    (module.exports = exports.default));
})(browser, browser.exports);
var Delegate = getDefaultExportFromCjs(browser.exports),
  pageTransition = () => {
    const pageTransitionOverlay = document.querySelector("#page-transition-overlay");
    pageTransitionOverlay &&
      (pageTransitionOverlay.classList.remove("skip-transition"),
      setTimeout(function () {
        pageTransitionOverlay.classList.remove("active");
      }, 0),
      setTimeout(() => {
        pageTransitionOverlay.classList.remove("active");
      }, 200),
      new Delegate(document.body).on(
        "click",
        'a[href]:not([href^="#"]):not(.no-transition):not([href^="mailto:"]):not([href^="tel:"]):not([target="_blank"])',
        function (event, target) {
          if (event.ctrlKey || event.metaKey) return;
          event.preventDefault();
          let linkHint = document.createElement("link");
          (linkHint.setAttribute("rel", "prerender"),
            linkHint.setAttribute("href", target.href),
            document.head.appendChild(linkHint),
            setTimeout(() => {
              window.location.href = target.href;
            }, 200),
            pageTransitionOverlay.classList.add("active"));
        },
      ),
      (window.onpageshow = function (e) {
        e.persisted && pageTransitionOverlay.classList.remove("active");
      }));
  },
  createFocusTrap = function (element, userOptions) {
    var _trap = null,
      _queue = [];
    (
      window.flu._focusTrapReady || (window.flu._focusTrapReady = import(flu.chunks.focusTrap).then(function () {}))
    ).then(function () {
      _trap = window._flu_createFocusTrap(element, userOptions);
      _queue.forEach(function (fn) {
        fn(_trap);
      });
      _queue.length = 0;
    });
    return {
      activate: function (opts) {
        _trap
          ? _trap.activate(opts)
          : _queue.push(function (t) {
              t.activate(opts);
            });
        return this;
      },
      deactivate: function (opts) {
        _trap
          ? _trap.deactivate(opts)
          : _queue.push(function (t) {
              t.deactivate(opts);
            });
        return this;
      },
      pause: function () {
        _trap && _trap.pause();
        return this;
      },
      unpause: function () {
        _trap && _trap.unpause();
        return this;
      },
    };
  };
var hasPassiveEvents = !1;
if ("undefined" != typeof window) {
  var passiveTestOptions = {
    get passive() {
      hasPassiveEvents = !0;
    },
  };
  (window.addEventListener("testPassive", null, passiveTestOptions),
    window.removeEventListener("testPassive", null, passiveTestOptions));
}
var isIosDevice =
    "undefined" != typeof window &&
    window.navigator &&
    window.navigator.platform &&
    (/iP(ad|hone|od)/.test(window.navigator.platform) ||
      ("MacIntel" === window.navigator.platform && window.navigator.maxTouchPoints > 1)),
  locks = [],
  documentListenerAdded = !1,
  initialClientY = -1,
  previousBodyOverflowSetting = void 0,
  previousBodyPaddingRight = void 0,
  allowTouchMove = function (el) {
    return locks.some(function (lock) {
      return !(!lock.options.allowTouchMove || !lock.options.allowTouchMove(el));
    });
  },
  preventDefault$1 = function (rawEvent) {
    var e = rawEvent || window.event;
    return !!allowTouchMove(e.target) || e.touches.length > 1 || (e.preventDefault && e.preventDefault(), !1);
  },
  setOverflowHidden = function (options) {
    if (void 0 === previousBodyPaddingRight) {
      var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
      options &&
        !0 === options.reserveScrollBarGap &&
        scrollBarGap > 0 &&
        ((previousBodyPaddingRight = document.body.style.paddingRight),
        (document.body.style.paddingRight = scrollBarGap + "px"));
    }
    void 0 === previousBodyOverflowSetting &&
      ((previousBodyOverflowSetting = document.body.style.overflow), (document.body.style.overflow = "hidden"));
  },
  restoreOverflowSetting = function () {
    (void 0 !== previousBodyPaddingRight &&
      ((document.body.style.paddingRight = previousBodyPaddingRight), (previousBodyPaddingRight = void 0)),
      void 0 !== previousBodyOverflowSetting &&
        ((document.body.style.overflow = previousBodyOverflowSetting), (previousBodyOverflowSetting = void 0)));
  },
  isTargetElementTotallyScrolled = function (targetElement) {
    return !!targetElement && targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight;
  },
  handleScroll = function (event, targetElement) {
    var clientY = event.targetTouches[0].clientY - initialClientY;
    return (
      !allowTouchMove(event.target) &&
      ((targetElement && 0 === targetElement.scrollTop && clientY > 0) ||
      (isTargetElementTotallyScrolled(targetElement) && clientY < 0)
        ? preventDefault$1(event)
        : (event.stopPropagation(), !0))
    );
  },
  disableBodyScroll = function (targetElement, options) {
    if (targetElement) {
      if (
        !locks.some(function (lock) {
          return lock.targetElement === targetElement;
        })
      ) {
        var lock = { targetElement: targetElement, options: options || {} };
        ((locks = [].concat(_toConsumableArray(locks), [lock])),
          isIosDevice
            ? ((targetElement.ontouchstart = function (event) {
                1 === event.targetTouches.length && (initialClientY = event.targetTouches[0].clientY);
              }),
              (targetElement.ontouchmove = function (event) {
                1 === event.targetTouches.length && handleScroll(event, targetElement);
              }),
              documentListenerAdded ||
                (document.addEventListener("touchmove", preventDefault$1, hasPassiveEvents ? { passive: !1 } : void 0),
                (documentListenerAdded = !0)))
            : setOverflowHidden(options));
      }
    } else
      console.error(
        "disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.",
      );
  },
  enableBodyScroll = function (targetElement) {
    targetElement
      ? ((locks = locks.filter(function (lock) {
          return lock.targetElement !== targetElement;
        })),
        isIosDevice
          ? ((targetElement.ontouchstart = null),
            (targetElement.ontouchmove = null),
            documentListenerAdded &&
              0 === locks.length &&
              (document.removeEventListener("touchmove", preventDefault$1, hasPassiveEvents ? { passive: !1 } : void 0),
              (documentListenerAdded = !1)))
          : locks.length || restoreOverflowSetting())
      : console.error(
          "enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.",
        );
  },
  n$1 = function (n) {
    if ("object" != typeof (t = n) || Array.isArray(t)) throw "state should be an object";
    var t;
  },
  t$1 = function (n, t, e, c) {
    return ((r = n),
    r.reduce(function (n, t, e) {
      return n.indexOf(t) > -1 ? n : n.concat(t);
    }, []))
      .reduce(function (n, e) {
        return n.concat(t[e] || []);
      }, [])
      .map(function (n) {
        return n(e, c);
      });
    var r;
  },
  e$1 = a(),
  c = e$1.on,
  r$1 = e$1.emit,
  o$1 = e$1.hydrate;
function a(e) {
  void 0 === e && (e = {});
  var c = {};
  return {
    getState: function () {
      return Object.assign({}, e);
    },
    hydrate: function (r) {
      return (
        n$1(r),
        Object.assign(e, r),
        function () {
          var n = ["*"].concat(Object.keys(r));
          t$1(n, c, e);
        }
      );
    },
    on: function (n, t) {
      return (
        (n = [].concat(n)).map(function (n) {
          return (c[n] = (c[n] || []).concat(t));
        }),
        function () {
          return n.map(function (n) {
            return c[n].splice(c[n].indexOf(t), 1);
          });
        }
      );
    },
    emit: function (r, o, u) {
      var a = ("*" === r ? [] : ["*"]).concat(r);
      ((o = "function" == typeof o ? o(e) : o) && (n$1(o), Object.assign(e, o), (a = a.concat(Object.keys(o)))),
        t$1(a, c, e, u));
    },
  };
}
function wrapIframes() {
  (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : []).forEach((el) => {
    const wrapper = document.createElement("div");
    (wrapper.classList.add("rte__iframe"),
      el.parentNode.insertBefore(wrapper, el),
      wrapper.appendChild(el),
      (el.src = el.src));
  });
}
function wrapTables() {
  (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : []).forEach((el) => {
    const wrapper = document.createElement("div");
    (wrapper.classList.add("rte__table-wrapper"),
      (wrapper.tabIndex = 0),
      el.parentNode.insertBefore(wrapper, el),
      wrapper.appendChild(el));
  });
}
const classes$I = { visible: "is-visible", active: "active", fixed: "is-fixed" },
  selectors$1I = { closeBtn: "[data-modal-close]", wash: ".modal__wash", modalContent: ".modal__content" },
  modal = (node) => {
    const focusTrap = createFocusTrap(node, { allowOutsideClick: !0 }),
      modalContent = n$2(selectors$1I.modalContent, node);
    new Delegate(document).on("click", selectors$1I.wash, () => _close());
    const events = [
        e$2(n$2(selectors$1I.closeBtn, node), "click", (e) => {
          (e.preventDefault(), _close());
        }),
        e$2(node, "keydown", (_ref) => {
          let { keyCode: keyCode } = _ref;
          27 === keyCode && _close();
        }),
        c("modal:open", (state, _ref2) => {
          let { modalContent: modalContent, narrow: narrow = !1 } = _ref2;
          (l(node, "modal--narrow", narrow), _renderModalContent(modalContent), _open());
        }),
      ],
      _renderModalContent = (content) => {
        const clonedContent = content.cloneNode(!0);
        ((modalContent.innerHTML = ""),
          modalContent.appendChild(clonedContent),
          wrapIframes(t$2("iframe", modalContent)),
          wrapTables(t$2("table", modalContent)));
      },
      _open = () => {
        (u$1(node, classes$I.active),
          document.body.setAttribute("data-fluorescent-overlay-open", "true"),
          focusTrap.activate(),
          disableBodyScroll(node, {
            allowTouchMove: (el) => {
              for (; el && el !== document.body; ) {
                if (null !== el.getAttribute("data-scroll-lock-ignore")) return !0;
                el = el.parentNode;
              }
            },
            reserveScrollBarGap: !0,
          }));
      },
      _close = () => {
        (focusTrap.deactivate(),
          i$1(node, classes$I.active),
          document.body.setAttribute("data-fluorescent-overlay-open", "false"),
          enableBodyScroll(node),
          setTimeout(() => {
            modalContent.innerHTML = "";
          }, 300));
      };
    return {
      unload: () => {
        events.forEach((unsubscribe) => unsubscribe());
      },
    };
  };
var AnimateProductItem = (items) => {
  const events = [];
  return (
    items.forEach((item) => {
      n$2(".product-item__image--one", item);
      const imageTwo = n$2(".product-item__image--two", item);
      (t$2(".product-item-options__list", item),
        events.push(
          e$2(item, "mouseenter", () => {
            !(function (imageOne, imageTwo) {
              imageTwo && u$1(imageTwo, "active");
            })(0, imageTwo);
          }),
        ),
        events.push(
          e$2(item, "mouseleave", () => {
            !(function (imageOne, imageTwo) {
              imageTwo && i$1(imageTwo, "active");
            })(0, imageTwo);
          }),
        ));
    }),
    {
      destroy() {
        events.forEach((unsubscribe) => unsubscribe());
      },
    }
  );
};
function getMediaQuery(querySize) {
  return (
    getComputedStyle(document.documentElement).getPropertyValue("--media-".concat(querySize)) ||
    (console.warn("Invalid querySize passed to getMediaQuery"), !1)
  );
}
var intersectionWatcher = function (node) {
    let instant = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
    const margin = window.matchMedia(getMediaQuery("above-720")).matches ? 200 : 100;
    let threshold = 0;
    instant || (threshold = Math.min(margin / node.offsetHeight, 0.5));
    const observer = new IntersectionObserver(
      (_ref) => {
        let [{ isIntersecting: visible }] = _ref;
        visible && (u$1(node, "is-visible"), observer.disconnect());
      },
      { threshold: threshold },
    );
    return (
      observer.observe(node),
      {
        destroy() {
          null == observer || observer.disconnect();
        },
      }
    );
  },
  delayOffset = function (node, items) {
    let delayOffset = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
    items.forEach((selector) => {
      t$2(selector, node).forEach((item) => {
        (item.style.setProperty("--delay-offset-multiplier", delayOffset), delayOffset++);
      });
    });
  },
  shouldAnimate = (node) => a$1(node, "animation") && !a$1(document.documentElement, "prefers-reduced-motion");
function makeRequest(method, url) {
  return new Promise(function (resolve, reject) {
    let xhr = new XMLHttpRequest();
    (xhr.open(method, url),
      (xhr.onload = function () {
        this.status >= 200 && this.status < 300 ? resolve(xhr.response) : reject(new Error(this.status));
      }),
      (xhr.onerror = function () {
        reject(new Error(this.status));
      }),
      xhr.send());
  });
}
const classes$u = { active: "active" },
  selectors$W = {
    drawerTrigger: "[data-store-availability-drawer-trigger]",
    closeBtn: "[data-store-availability-close]",
    productTitle: "[data-store-availability-product-title]",
    variantTitle: "[data-store-availability-variant-title]",
    storeListContainer: "[data-store-list-container]",
    storeListContent: "[data-store-availability-list-content]",
    wash: "[data-store-availability-drawer-wash]",
    parentWrapper: "[data-store-availability-container]",
  },
  storeAvailabilityDrawer = (node) => {
    var focusTrap = createFocusTrap(node, { allowOutsideClick: !0 });
    const wash = n$2(selectors$W.wash, node.parentNode),
      productTitleContainer = n$2(selectors$W.productTitle),
      variantTitleContainer = n$2(selectors$W.variantTitle),
      storeListContainer = n$2(selectors$W.storeListContainer, node);
    let storeAvailabilityDrawerAnimate = null;
    shouldAnimate(node) && (storeAvailabilityDrawerAnimate = animateStoreAvailabilityDrawer(node));
    const events = [
        e$2([n$2(selectors$W.closeBtn, node), wash], "click", (e) => {
          (e.preventDefault(), _close());
        }),
        e$2(node, "keydown", (_ref) => {
          let { keyCode: keyCode } = _ref;
          27 === keyCode && _close();
        }),
      ],
      _open = () => {
        (u$1(node, classes$u.active),
          shouldAnimate(node) && storeAvailabilityDrawerAnimate.animate(),
          node.setAttribute("aria-hidden", "false"),
          focusTrap.activate(),
          document.body.setAttribute("data-fluorescent-overlay-open", "true"),
          disableBodyScroll(node, {
            allowTouchMove: (el) => {
              for (; el && el !== document.body; ) {
                if (null !== el.getAttribute("data-scroll-lock-ignore")) return !0;
                el = el.parentNode;
              }
            },
            reserveScrollBarGap: !0,
          }));
      },
      _close = () => {
        (focusTrap.deactivate(),
          i$1(node, classes$u.active),
          node.setAttribute("aria-hidden", "true"),
          setTimeout(() => {
            (shouldAnimate(node) && storeAvailabilityDrawerAnimate.reset(),
              document.body.setAttribute("data-fluorescent-overlay-open", "false"),
              enableBodyScroll(node));
          }, 500));
      };
    return (
      new Delegate(document.body).on("click", selectors$W.drawerTrigger, (_, target) =>
        ((target) => {
          const parentContainer = target.closest(selectors$W.parentWrapper),
            {
              baseUrl: baseUrl,
              variantId: variantId,
              productTitle: productTitle,
              variantTitle: variantTitle,
            } = parentContainer.dataset;
          makeRequest("GET", "".concat(baseUrl, "/variants/").concat(variantId, "/?section_id=store-availability"))
            .then((storeAvailabilityHTML) => {
              let container = document.createElement("div");
              ((container.innerHTML = storeAvailabilityHTML),
                (productTitleContainer.innerText = productTitle),
                (variantTitleContainer.innerText = "null" === variantTitle ? "" : variantTitle));
              const storeList = n$2(selectors$W.storeListContent, container);
              ((storeListContainer.innerHTML = ""), storeListContainer.appendChild(storeList));
            })
            .then(_open);
        })(target),
      ),
      {
        unload: () => {
          events.forEach((unsubscribe) => unsubscribe());
        },
      }
    );
  },
  {
    strings: { accessibility: strings$7 },
  } = window.theme,
  handleTab = () => {
    let tabHandler = null;
    const formElments = ["INPUT", "TEXTAREA", "SELECT"];
    function handleFirstTab(e) {
      9 !== e.keyCode ||
        formElments.includes(document.activeElement.tagName) ||
        (document.body.classList.add("user-is-tabbing"),
        tabHandler(),
        (tabHandler = e$2(window, "mousedown", handleMouseDownOnce)));
    }
    function handleMouseDownOnce() {
      (document.body.classList.remove("user-is-tabbing"),
        tabHandler(),
        (tabHandler = e$2(window, "keydown", handleFirstTab)));
    }
    tabHandler = e$2(window, "keydown", handleFirstTab);
  },
  focusFormStatus = (node) => {
    const formStatus = n$2(".form-status", node);
    if (!formStatus) return;
    const focusElement = n$2("[data-form-status]", formStatus);
    focusElement && focusElement.focus();
  },
  prefersReducedMotion = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;
function backgroundVideoHandler(container) {
  const pause = n$2(".video-pause", container),
    video = container.getElementsByTagName("VIDEO")[0];
  if (!pause || !video) return;
  const pauseVideo = () => {
    (video.pause(), (pause.innerText = strings$7.play_video));
  };
  prefersReducedMotion() && pauseVideo();
  const pauseListener = e$2(pause, "click", (e) => {
    (e.preventDefault(), video.paused ? (video.play(), (pause.innerText = strings$7.pause_video)) : pauseVideo());
  });
  return () => pauseListener();
}
const classes$t = { hidden: "hidden" };
var sectionClasses = () => {
  function adjustClasses() {
    t$2(".main .shopify-section").forEach((section) => {
      const { firstElementChild: child } = section;
      child && child.classList.contains(classes$t.hidden) && u$1(section, classes$t.hidden);
    });
  }
  (adjustClasses(), e$2(document, "shopify:section:load", adjustClasses));
};
const dispatchCustomEvent = function (eventName) {
  let data = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  const event = new CustomEvent(eventName, data ? { detail: data } : null);
  document.dispatchEvent(event);
};
function getVariantFromId(product, value) {
  if ((_validateProductStructure(product), "number" != typeof value)) throw new TypeError(value + " is not a Number.");
  return (
    product.variants.filter(function (variant) {
      return variant.id === value;
    })[0] || null
  );
}
function getVariantFromSerializedArray(product, collection) {
  return (
    _validateProductStructure(product),
    getVariantFromOptionArray(product, _createOptionArrayFromOptionCollection(product, collection))
  );
}
function getVariantFromOptionArray(product, options) {
  return (
    _validateProductStructure(product),
    _validateOptionsArray(options),
    product.variants.filter(function (variant) {
      return options.every(function (option, index) {
        return variant.options[index] === option;
      });
    })[0] || null
  );
}
function _createOptionArrayFromOptionCollection(product, collection) {
  (_validateProductStructure(product), _validateSerializedArray(collection));
  var optionArray = [];
  return (
    collection.forEach(function (option) {
      for (var i = 0; i < product.options.length; i++)
        if (product.options[i].name.toLowerCase() === option.name.toLowerCase()) {
          optionArray[i] = option.value;
          break;
        }
    }),
    optionArray
  );
}
function _validateProductStructure(product) {
  if ("object" != typeof product) throw new TypeError(product + " is not an object.");
  if (0 === Object.keys(product).length && product.constructor === Object) throw new Error(product + " is empty.");
}
function _validateSerializedArray(collection) {
  if (!Array.isArray(collection)) throw new TypeError(collection + " is not an array.");
  if (0 === collection.length) return [];
  if (!collection[0].hasOwnProperty("name")) throw new Error(collection[0] + "does not contain name key.");
  if ("string" != typeof collection[0].name)
    throw new TypeError(
      "Invalid value type passed for name of option " + collection[0].name + ". Value should be string.",
    );
}
function _validateOptionsArray(options) {
  if (Array.isArray(options) && "object" == typeof options[0])
    throw new Error(options + "is not a valid array of options.");
}
function getUrlWithVariant(url, id) {
  return /variant=/.test(url)
    ? url.replace(/(variant=)[^&]+/, "$1" + id)
    : /\?/.test(url)
      ? url.concat("&variant=").concat(id)
      : url.concat("?variant=").concat(id);
}
const selectors$V = {
    sentinal: ".scroll-sentinal",
    scrollButtons: ".scroll-button",
    scrollViewport: "[data-scroll-container-viewport]",
  },
  scrollContainer = (node) => {
    const sentinals = t$2(selectors$V.sentinal, node),
      buttons = t$2(selectors$V.scrollButtons, node),
      { axis: axis, startAtEnd: startAtEnd } = node.dataset,
      scrollerViewport = n$2(selectors$V.scrollViewport, node);
    window.addEventListener(
      "load",
      () => {
        (u$1(node, "scroll-container-initialized"),
          "true" === startAtEnd &&
            ((scrollerViewport["vertical" == axis ? "scrollTop" : "scrollLeft"] =
              2 * scrollerViewport["vertical" == axis ? "scrollHeight" : "scrollWidth"]),
            (node.dataset.startAtEnd = !1)));
      },
      { once: !0 },
    );
    const events = [
        e$2(buttons, "click", (e) => {
          const scrollAttribute = "vertical" == axis ? "scrollTop" : "scrollLeft";
          "start" === e.currentTarget.dataset.position
            ? scrollerViewport[scrollAttribute] < 150
              ? (scrollerViewport[scrollAttribute] = 0)
              : (scrollerViewport[scrollAttribute] -= 100)
            : (scrollerViewport[scrollAttribute] += 100);
        }),
      ],
      intersectionObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach((entry) => {
            const visible = entry.isIntersecting;
            node.setAttribute("data-at-".concat(entry.target.dataset.position), visible ? "true" : "false");
          });
        },
        { root: scrollerViewport },
      );
    return (
      sentinals.forEach((sentinal) => {
        intersectionObserver.observe(sentinal);
      }),
      {
        unload: () => {
          (sentinals.forEach((sentinal) => {
            intersectionObserver.unobserve(sentinal);
          }),
            events.forEach((unsubscribe) => unsubscribe()));
        },
      }
    );
  };
var n,
  e,
  i,
  o,
  t,
  r,
  f,
  d,
  p,
  u = [];
function w(n, a) {
  if (u.length === 0) { n = null; return; }
  return (
    (e = window.pageXOffset),
    (o = window.pageYOffset),
    (r = window.innerHeight),
    (d = window.innerWidth),
    void 0 === i && (i = e),
    void 0 === t && (t = o),
    void 0 === p && (p = d),
    void 0 === f && (f = r),
    (a || o !== t || e !== i || r !== f || d !== p) &&
      ((function (n) {
        for (var w = 0; w < u.length; w++) u[w]({ x: e, y: o, px: i, py: t, vh: r, pvh: f, vw: d, pvw: p }, n);
      })(n),
      (i = e),
      (t = o),
      (f = r),
      (p = d)),
    requestAnimationFrame(w)
  );
}
function srraf(e) {
  return (
    u.indexOf(e) < 0 && u.push(e),
    (n = n || w(performance.now())),
    {
      update: function () {
        return (w(performance.now(), !0), this);
      },
      destroy: function () {
        u.splice(u.indexOf(e), 1);
        if (u.length === 0) n = null;
      },
    }
  );
}
const atBreakpointChange = (breakpointToWatch, callback) => {
    const mql = window.matchMedia("(max-width: ".concat(breakpointToWatch, "px)"));
    const handler = () => callback();
    mql.addEventListener("change", handler);
    return {
      unload: () => {
        mql.removeEventListener("change", handler);
      },
    };
  },
  sel$4 = {
    container: ".social-share",
    button: ".social-share__button",
    popup: ".social-sharing__popup",
    copyURLButton: ".social-share__copy-url",
    successMessage: ".social-share__success-message",
  },
  classes$s = { hidden: "hidden", linkCopied: "social-sharing__popup--success" };
var SocialShare = (node) => {
  if (!node) return Function();
  const button = n$2(sel$4.button, node),
    popup = n$2(sel$4.popup, node),
    copyURLButton = n$2(sel$4.copyURLButton, node),
    successMessage = n$2(sel$4.successMessage, node);
  let clickListener = e$2(window, "click", function (evt) {
    const buttonClicked = evt.target.closest(sel$4.button) === button,
      popupClicked = evt.target.closest(sel$4.popup) === popup,
      copyURLClicked = evt.target.closest(sel$4.copyURLButton) === copyURLButton;
    let isActive = !1;
    if (
      (buttonClicked && (isActive = "true" === button.getAttribute("aria-expanded")),
      popupClicked || close(),
      buttonClicked && !isActive && (button.setAttribute("aria-expanded", !0), popup.setAttribute("aria-hidden", !1)),
      copyURLClicked)
    ) {
      const { url: url } = copyURLButton.dataset;
      ((str = url), navigator.clipboard.writeText(str)).then(showSuccessMessage, showErrorMessage);
    }
    var str;
  });
  function close() {
    (button.setAttribute("aria-expanded", !1), popup.setAttribute("aria-hidden", !0));
  }
  function showMessage(message) {
    ((successMessage.innerHTML = message),
      i$1(successMessage, classes$s.hidden),
      u$1(popup, classes$s.linkCopied),
      setTimeout(() => {
        (u$1(successMessage, classes$s.hidden), i$1(popup, classes$s.linkCopied));
      }, 2e3));
  }
  function showSuccessMessage() {
    const { successMessage: successMessage } = copyURLButton.dataset;
    showMessage(successMessage);
  }
  function showErrorMessage() {
    const { errorMessage: errorMessage } = copyURLButton.dataset;
    showMessage(errorMessage || "Error copying link.");
  }
  return (
    (navigator.clipboard && navigator.clipboard.writeText) || u$1(copyURLButton, classes$s.hidden),
    function () {
      (close(), clickListener());
    }
  );
};
function localStorageAvailable() {
  try {
    return (
      localStorage.setItem("test", "test"),
      "test" === localStorage.getItem("test") && (localStorage.removeItem("test"), !0)
    );
  } catch (e) {
    return !1;
  }
}
const PREFIX = "fluco_";
function getStorage(key) {
  return localStorageAvailable() ? JSON.parse(localStorage.getItem(PREFIX + key)) : null;
}
function removeStorage(key) {
  return localStorageAvailable() ? (localStorage.removeItem(PREFIX + key), !0) : null;
}
function setStorage(key, val) {
  return localStorageAvailable() ? (localStorage.setItem(PREFIX + key, val), !0) : null;
}
function _cartLoad() {
  return window.flu._cartReady || (window.flu._cartReady = import(flu.chunks.cart).then(function () {}));
}
var cart = {
  addItem: function (form) {
    return _cartLoad().then(function () {
      return window._flu_cart.addItem(form);
    });
  },
  get: function () {
    return _cartLoad().then(function () {
      return window._flu_cart.get();
    });
  },
  updateItem: function (k, q) {
    return _cartLoad().then(function () {
      return window._flu_cart.updateItem(k, q);
    });
  },
  addItemById: function (id, q) {
    return _cartLoad().then(function () {
      return window._flu_cart.addItemById(id, q);
    });
  },
  addItemsById: function (items) {
    return _cartLoad().then(function () {
      return window._flu_cart.addItemsById(items);
    });
  },
};
const moneyFormat = "${{amount}}";
function formatMoney$1(cents, format) {
  "string" == typeof cents && (cents = cents.replace(".", ""));
  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || moneyFormat;
  function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
    if (isNaN(number) || null == number) return 0;
    const parts = (number = (number / 100).toFixed(precision)).split(".");
    return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`) + (parts[1] ? decimal + parts[1] : "");
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
  }
  return formatString.replace(placeholderRegex, value);
}
var formatMoney = (val) => formatMoney$1(val, window.theme.moneyFormat || "${{amount}}"),
  getProduct = (handle) => (cb) =>
    fetch("".concat(window.theme.routes.products, "/").concat(handle, ".js"))
      .then((res) => res.json())
      .then((data) => cb(data))
      .catch((err) => console.log(err.message));
((window.flu = window.flu || {}),
  (window.flu._animationsReady =
    !document.querySelector(".animation") || window.matchMedia("(prefers-reduced-motion: reduce)").matches
      ? Promise.resolve()
      : new Promise(function (resolve, reject) {
          var s = document.createElement("script");
          ((s.src = flu.chunks.animations), (s.onload = resolve), (s.onerror = reject), document.head.appendChild(s));
        })));
